// Moment
import moment from "moment";
import fr from "./fr";
moment.locale('fr', fr);
